<template>
    <component :is="option.attribute.borderType"
               :backgroundColor="option.attribute.backgroundColor"
               :color="[option.attribute.borderColor1, option.attribute.borderColor2]"
               :dur="option.attribute.dur"
               :reverse="option.attribute.reverse"
               :style="{width:width+'px',height:height+'px'}"
               :title="option.attribute.borderTitle"
               :titleWidth="option.attribute.titleWidth"/>
</template>

<script>
export default {
    name: "cpt-dataV-border",
    props: {
        width: Number,
        height: Number,
        option: Object
    },
    data() {
        return {}
    }
}
</script>

<style scoped>

</style>
